import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // New loading state

  // Check if the user is authenticated
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
        setIsAuthenticated(response.data.isAuthenticated);
        setUser(response.data.user);
      } catch (error) {
        console.error("Error validating token:", error);
        setIsAuthenticated(false);
        setUser(null);
      } finally {
        setLoading(false); // Mark loading as complete after check
      }
    };

    checkAuth();
  }, []);

  // Only render children if the authentication check is complete
  if (loading) {
    return <div>Loading...</div>; // or a spinner, depending on your preference
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, setIsAuthenticated, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
